import { createInertiaApp, router } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createApp, h } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import '../css/style.css';
import 'preline/dist';
import { HSOverlay } from 'preline';
import { initializeTheme } from './composables/useAppearance';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
    title: (title) => (title ? `${title} - ${appName}` : appName),
    resolve: (name) =>
        resolvePageComponent(
            `./pages/${name}.vue`,
            import.meta.glob('./pages/**/*.vue'),
        ),
    setup({ el, App, props, plugin }) {
        const pinia = createPinia();
        pinia.use(piniaPluginPersistedstate);

        createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(pinia)
            .mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});

// This will set light / dark mode on page load...
initializeTheme();

// Clean up Preline components before Inertia navigation to prevent stale event listeners
router.on('before', () => {
    // Close any open modals
    document.querySelectorAll('.hs-overlay').forEach((modal) => {
        if (!modal.classList.contains('hidden')) {
            HSOverlay.close(`#${modal.id}`);
        }
    });

    // Safety net: ensure body scroll is restored
    document.body.classList.remove('overflow-hidden');

    // Remove any stale backdrop elements
    document.querySelectorAll('.hs-overlay-backdrop').forEach((el) => el.remove());
});

// Reinitialize Preline UI components after each Inertia page navigation
router.on('navigate', () => {
    setTimeout(() => {
        if (window.HSStaticMethods?.autoInit) {
            window.HSStaticMethods.autoInit();
        }
    }, 0);
});
